import { Component, input, linkedSignal } from '@angular/core';
import { OrganizationCreateFormModel, toModel } from './definitions';
import { form, FormField, required } from '@angular/forms/signals';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputLabel, InputSimple, ToggleLabel, Toggle } from 'excellence-ui';
import { FieldErrors } from '../../../../shared/components/field-errors/field-errors';
import { OrganizationResponse } from '../../../../core/clients/omni-core/models';

@Component({
  selector: 'app-organization-create-address-form',
  imports: [TranslocoPipe, FormField, InputLabel, InputSimple, FieldErrors, ToggleLabel, Toggle],
  templateUrl: './organization-create-address-form.html',
})
export class OrganizationCreateAddressForm {
  organization = input<OrganizationResponse | null | undefined>(null);

  private organizationModel = linkedSignal<OrganizationCreateFormModel>(() => {
    const organization = this.organization() ?? null;
    return toModel(organization);
  });

  organizationForm = form(this.organizationModel, (schemaPath) => {
    // address
    required(schemaPath.address.city);
    required(schemaPath.address.street);
    required(schemaPath.address.streetNumber);
    required(schemaPath.address.zipCode);
    // billingAddress
    required(schemaPath.billingAddress.city, {
      when: ({ valueOf }) => valueOf(schemaPath.hasDifferentBillingAddress) === true,
    });
    required(schemaPath.billingAddress.street, {
      when: ({ valueOf }) => valueOf(schemaPath.hasDifferentBillingAddress) === true,
    });
    required(schemaPath.billingAddress.streetNumber, {
      when: ({ valueOf }) => valueOf(schemaPath.hasDifferentBillingAddress) === true,
    });
    required(schemaPath.billingAddress.zipCode, {
      when: ({ valueOf }) => valueOf(schemaPath.hasDifferentBillingAddress) === true,
    });
  });

  markAsTouched() {
    this.organizationForm.address.city().markAsTouched();
    this.organizationForm.address.street().markAsTouched();
    this.organizationForm.address.streetNumber().markAsTouched();
    this.organizationForm.address.zipCode().markAsTouched();
    this.organizationForm.billingAddress.city().markAsTouched();
    this.organizationForm.billingAddress.street().markAsTouched();
    this.organizationForm.billingAddress.streetNumber().markAsTouched();
    this.organizationForm.billingAddress.zipCode().markAsTouched();
  }
}
